module.exports = __webpack_public_path__ + "static/fonts/Poppins-Light.fcc40ae.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-Light.ttf
// module id = 1028
// module chunks = 11